import { IconButton, Switch } from "@chakra-ui/react";
import { useState } from "react";
import { RiDeleteBinLine, RiFileEditLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import { openCreateChapterModel } from "../../../modules/admin-modules/models/Actions";
import {
  deleteChapterRequest,
  editChapterRequest,
} from "../../../modules/superadmin-modules/chapters/Actions";

const ChaptersTable = ({ setAdd, setSelectedData }) => {
  const { chapters, isLoading } = useSelector(
    (state) => state.superadminChapters
  );
  const dispatch = useDispatch();
  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [selected, setSelected] = useState({
    id: "",
  });
  const viewData = (data) => {
    setSelectedData(data);
    setSelected(data);
  };
  const Data = chapters?.map((data) => {
    return {
      ...data,
      active: (
        <Switch
          onChange={() => {
            let formData = new FormData();
            formData.append("active", data?.active ? false : true);
            formData.append("_method", "PUT");
            dispatch(
              editChapterRequest({
                formData: {
                  active: data?.active ? false : true
                },
                id: data?.id,
              })
            );
          }}
          isChecked={data?.active}
        />
      ),
      edit: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiFileEditLine />}
          onClick={() => {
            setAdd(false);
            dispatch(openCreateChapterModel());
          }}
        />
      ),
      delete: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiDeleteBinLine color="red" />}
          onClick={() => dispatch(deleteChapterRequest(data?.id))}
        />
      ),
    };
  });
  const columns = [
    {
      Header: " الفصل",
      accessor: "name",
    },
    {
      Header: " Active",
      accessor: "active",
    },

    {
      Header: "تعديل",
      accessor: "edit",
    },
    {
      Header: "حذف",
      accessor: "delete",
    },
  ];

  return (
    <CTable
      selectedData={viewData}
      Columns={columns}
      Data={Data}
      path={"openModel"}
      Actions
      Title={``}
      subTitle=""
      btnTitle=""
      placeHolder=""
      noSearchBar={true}
      noFilter={true}
      footerBtnTitle
      filterList
      addButton
      addButtonTitle=""
      setPage={setPage}
      setPerPage={setPerPage}
      currentpage={pageNumber}
      setPageNumber={setPageNumber}
      noSecondSearchBar={true}
      isLoading={isLoading}
      perPage={size}
      totalPage={Math.ceil(chapters?.length / 10)}
    />
  );
};

export default ChaptersTable;
